import { DomEvent } from "./DomEvent";
import { Event, EventListener } from "./Event";
import { Table } from "../components/table/Table";
import { TableRow } from "../components/table/TableRow";

export interface TableRowDisplayListener extends EventListener<TableRowDisplayEvent> {
}

export class TableRowDisplayEvent extends Event<TableRow> {
    private table: Table = null;

    constructor(component: TableRow, table: Table, domEvent?: DomEvent) {
        super(component, domEvent);
        this.table = table;
    }

    public getTableRow(): TableRow {
        return this.target as TableRow;
    }

    public getTable(): Table {
        return this.table;
    }
}
